/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */

import { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import type { FilterId } from '../filters';

const ProductsOrder3P: ProductKeys3P[] = [
	// Loom is actually a 1P so goes to the top
	ProductKeys3P.Loom,

	// Eventually this might be "smart"
	// For now this static order isn't strongly defined
	ProductKeys3P.GoogleDrive,
	ProductKeys3P.Sharepoint,
	ProductKeys3P.OneDrive,
	ProductKeys3P.Dropbox,
	ProductKeys3P.Slack,
	ProductKeys3P.Teams,
	ProductKeys3P.Github,
	ProductKeys3P.Figma,
	ProductKeys3P.GoogleCalendar,
	ProductKeys3P.Gmail,
	ProductKeys3P.OutlookCalendar,
	ProductKeys3P.OutlookMail,
	ProductKeys3P.Airtable,
	ProductKeys3P.Smartsheet,
	ProductKeys3P.Asana,
	ProductKeys3P.Zendesk,
	ProductKeys3P.Miro,
	ProductKeys3P.Docusign,
	ProductKeys3P.Lucid,
	ProductKeys3P.Monday,
	ProductKeys3P.AzureDevops,
	ProductKeys3P.Gitlab,
	ProductKeys3P.ConfluenceDC,
	ProductKeys3P.Canva,
	ProductKeys3P.Box,
	ProductKeys3P.Zeplin,
	ProductKeys3P.ServiceNow,
	ProductKeys3P.Freshservice,
	ProductKeys3P.PowerBI,
	ProductKeys3P.ClickUp,
	ProductKeys3P.Amplitude,
	ProductKeys3P.Stripe,
	ProductKeys3P.AdobeXD,
	ProductKeys3P.Aha,
	ProductKeys3P.AdobeSign,
	ProductKeys3P.Mural,
	ProductKeys3P.Webex,
	ProductKeys3P.PagerDuty,
	ProductKeys3P.Pipedrive,
	ProductKeys3P.Dovetail,
	ProductKeys3P.LaunchDarkly,
	ProductKeys3P.Salesforce,
	ProductKeys3P.Sentry,
	ProductKeys3P.Gitbook,
	ProductKeys3P.AWSS3,
	ProductKeys3P.ForgeAdamVitareqDev,
	ProductKeys3P.ForgeAdamVitareqProd,
	ProductKeys3P.ForgeK15tScrollSitesDev,
	ProductKeys3P.ForgeK15tScrollSitesProd,
	ProductKeys3P.ForgePioAwsDev,
	ProductKeys3P.ForgePioAwsProd,
	ProductKeys3P.ForgePioClickupDev,
	ProductKeys3P.ForgePioClickupProd,
	ProductKeys3P.ForgePioGithubDev,
	ProductKeys3P.ForgePioGithubProd,
	ProductKeys3P.ForgePioGitbookDev,
	ProductKeys3P.ForgePioGitbookProd,
	ProductKeys3P.ForgePioGitlabDev,
	ProductKeys3P.ForgePioGitlabProd,
	ProductKeys3P.ForgePioGoogleDriveDev,
	ProductKeys3P.ForgePioGoogleDriveProd,
	ProductKeys3P.ForgePioGuruDev,
	ProductKeys3P.ForgePioGuruProd,
	ProductKeys3P.ForgePioHelpjuiceDev,
	ProductKeys3P.ForgePioHelpjuiceProd,
	ProductKeys3P.ForgePioHubspotDev,
	ProductKeys3P.ForgePioHubspotProd,
	ProductKeys3P.ForgePioSalesforceDev,
	ProductKeys3P.ForgePioSalesforceProd,
	ProductKeys3P.ForgePioSharepointDev,
	ProductKeys3P.ForgePioSharepointProd,
	ProductKeys3P.ForgePioStackOverflowDev,
	ProductKeys3P.ForgePioStackOverflowProd,
	ProductKeys3P.ForgeUtoolityGitbookDev,
	ProductKeys3P.ForgeUtoolityGitbookProd,
	ProductKeys3P.ForgeGdriveEugeneTestDev,
	ProductKeys3P.ForgeGdriveEugeneTestProd,
	ProductKeys3P.ForgeUnitoSalesforceDev,
	ProductKeys3P.ForgeUnitoSalesforceProd,
	ProductKeys3P.ForgeUnitoServicenowDev,
	ProductKeys3P.ForgeUnitoServicenowProd,
	ProductKeys3P.ForgeUnitoWrikeDev,
	ProductKeys3P.ForgeUnitoWrikeProd,
	ProductKeys3P.ForgeUnitoAsanaDev,
	ProductKeys3P.ForgeUnitoAsanaProd,
	ProductKeys3P.ForgeUnitoBasecampDev,
	ProductKeys3P.ForgeUnitoBasecampProd,
	// New 3P? Add it here
	ProductKeys3P.Databricks,
	ProductKeys3P.Notion,
	ProductKeys3P.Todoist,
	ProductKeys3P.Hubspot,
	ProductKeys3P.Gong,
	ProductKeys3P.Zoom,
	ProductKeys3P.JiraDC,
	ProductKeys3P.JsmDC,

	// Always last
	ProductKeys3P.AtlassianWebCrawler,
];

// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const NewProductsOrder3P: ProductKeys3P[] = [
	// Loom is actually a 1P so goes to the top
	ProductKeys3P.Loom,

	// Eventually this might be "smart"
	// For now this static order isn't strongly defined
	ProductKeys3P.GoogleDrive,
	ProductKeys3P.Sharepoint,
	ProductKeys3P.Slack,
	ProductKeys3P.Teams,
	ProductKeys3P.Figma,
	ProductKeys3P.Miro,
	ProductKeys3P.Salesforce,
	ProductKeys3P.Github,
	ProductKeys3P.Gmail,
	ProductKeys3P.Gitlab,
	ProductKeys3P.Lucid,
	ProductKeys3P.Asana,
	ProductKeys3P.AzureDevops,
	ProductKeys3P.GoogleCalendar,
	ProductKeys3P.OneDrive,
	ProductKeys3P.Dropbox,
	ProductKeys3P.OutlookCalendar,
	ProductKeys3P.OutlookMail,
	ProductKeys3P.Airtable,
	ProductKeys3P.Smartsheet,
	ProductKeys3P.Zendesk,
	ProductKeys3P.Docusign,
	ProductKeys3P.Databricks,
	ProductKeys3P.Monday,
	ProductKeys3P.ConfluenceDC,
	ProductKeys3P.Canva,
	ProductKeys3P.Box,
	ProductKeys3P.Zeplin,
	ProductKeys3P.ServiceNow,
	ProductKeys3P.Freshservice,
	ProductKeys3P.PowerBI,
	ProductKeys3P.ClickUp,
	ProductKeys3P.Amplitude,
	ProductKeys3P.Stripe,
	ProductKeys3P.AdobeXD,
	ProductKeys3P.Aha,
	ProductKeys3P.AdobeSign,
	ProductKeys3P.Mural,
	ProductKeys3P.Webex,
	ProductKeys3P.PagerDuty,
	ProductKeys3P.Pipedrive,
	ProductKeys3P.Dovetail,
	ProductKeys3P.LaunchDarkly,
	ProductKeys3P.Sentry,
	ProductKeys3P.Gitbook,
	ProductKeys3P.AWSS3,
	ProductKeys3P.Notion,
	ProductKeys3P.Todoist,
	ProductKeys3P.Hubspot,
	ProductKeys3P.JiraDC,
	ProductKeys3P.JsmDC,

	// New 3P? Add it here
	ProductKeys3P.ForgeAdamVitareqDev,
	ProductKeys3P.ForgeAdamVitareqProd,
	ProductKeys3P.ForgeK15tScrollSitesDev,
	ProductKeys3P.ForgeK15tScrollSitesProd,
	ProductKeys3P.ForgePioAwsDev,
	ProductKeys3P.ForgePioAwsProd,
	ProductKeys3P.ForgePioClickupDev,
	ProductKeys3P.ForgePioClickupProd,
	ProductKeys3P.ForgePioGithubDev,
	ProductKeys3P.ForgePioGithubProd,
	ProductKeys3P.ForgePioGitbookDev,
	ProductKeys3P.ForgePioGitbookProd,
	ProductKeys3P.ForgePioGitlabDev,
	ProductKeys3P.ForgePioGitlabProd,
	ProductKeys3P.ForgePioGoogleDriveDev,
	ProductKeys3P.ForgePioGoogleDriveProd,
	ProductKeys3P.ForgePioGuruDev,
	ProductKeys3P.ForgePioGuruProd,
	ProductKeys3P.ForgePioHelpjuiceDev,
	ProductKeys3P.ForgePioHelpjuiceProd,
	ProductKeys3P.ForgePioHubspotDev,
	ProductKeys3P.ForgePioHubspotProd,
	ProductKeys3P.ForgePioSalesforceDev,
	ProductKeys3P.ForgePioSalesforceProd,
	ProductKeys3P.ForgePioSharepointDev,
	ProductKeys3P.ForgePioSharepointProd,
	ProductKeys3P.ForgePioStackOverflowDev,
	ProductKeys3P.ForgePioStackOverflowProd,
	ProductKeys3P.ForgeUtoolityGitbookDev,
	ProductKeys3P.ForgeUtoolityGitbookProd,
	ProductKeys3P.ForgeGdriveEugeneTestDev,
	ProductKeys3P.ForgeGdriveEugeneTestProd,
	ProductKeys3P.ForgeUnitoSalesforceDev,
	ProductKeys3P.ForgeUnitoSalesforceProd,
	ProductKeys3P.ForgeUnitoServicenowDev,
	ProductKeys3P.ForgeUnitoServicenowProd,
	ProductKeys3P.ForgeUnitoWrikeDev,
	ProductKeys3P.ForgeUnitoWrikeProd,
	ProductKeys3P.ForgeUnitoAsanaDev,
	ProductKeys3P.ForgeUnitoAsanaProd,
	ProductKeys3P.ForgeUnitoBasecampDev,
	ProductKeys3P.ForgeUnitoBasecampProd,
	ProductKeys3P.Gong,
	ProductKeys3P.Zoom,
	// Always last
	ProductKeys3P.AtlassianWebCrawler,
];

export { ProductsOrder3P, NewProductsOrder3P };

/**
 * Pre-computed mapping of filter IDs to 3P product keys that support them.
 * Avoids importing ThirdPartyConfigs (which includes React icon components).
 *
 * IMPORTANT: When adding a new 3P product with filter support, update this mapping
 * to match the `filters` array in the product's ThirdPartyConfig.
 * A sanity test verifies this mapping stays in sync with ThirdPartyConfigs.
 */
export const thirdPartyFilterProducts: Partial<Record<FilterId, ProductKeys3P[]>> = {
	// TODO: when cleaning up `rovo_fps_show_github_assignee_filter`, add Github + ForgePioGithubDev/Prod here.
	assignee: [ProductKeys3P.JiraDC, ProductKeys3P.JsmDC],
	campaignStatus: [ProductKeys3P.Salesforce],
	caseStatus: [ProductKeys3P.Salesforce],
	closeDate: [ProductKeys3P.Salesforce],
	// TODO: when cleaning up `rovo_fps_enable_sharepoint_content_filter`, add Sharepoint here.
	content: [ProductKeys3P.ConfluenceDC, ProductKeys3P.GoogleDrive],
	createdBy: [
		ProductKeys3P.ConfluenceDC,
		ProductKeys3P.ForgePioGithubDev,
		ProductKeys3P.ForgePioGithubProd,
		ProductKeys3P.Github,
		ProductKeys3P.Hubspot,
		ProductKeys3P.Salesforce,
	],
	label: [ProductKeys3P.ConfluenceDC],
	lastUpdated: [
		ProductKeys3P.Airtable,
		ProductKeys3P.Asana,
		ProductKeys3P.AzureDevops,
		ProductKeys3P.Box,
		ProductKeys3P.ConfluenceDC,
		ProductKeys3P.Databricks,
		ProductKeys3P.Docusign,
		ProductKeys3P.Dropbox,
		ProductKeys3P.Figma,
		ProductKeys3P.ForgeAdamVitareqDev,
		ProductKeys3P.ForgeAdamVitareqProd,
		ProductKeys3P.ForgeGdriveEugeneTestDev,
		ProductKeys3P.ForgeGdriveEugeneTestProd,
		ProductKeys3P.ForgeK15tScrollSitesDev,
		ProductKeys3P.ForgeK15tScrollSitesProd,
		ProductKeys3P.ForgePioAwsDev,
		ProductKeys3P.ForgePioAwsProd,
		ProductKeys3P.ForgePioClickupDev,
		ProductKeys3P.ForgePioClickupProd,
		ProductKeys3P.ForgePioGitbookDev,
		ProductKeys3P.ForgePioGitbookProd,
		ProductKeys3P.ForgePioGithubDev,
		ProductKeys3P.ForgePioGithubProd,
		ProductKeys3P.ForgePioGitlabDev,
		ProductKeys3P.ForgePioGitlabProd,
		ProductKeys3P.ForgePioGoogleDriveDev,
		ProductKeys3P.ForgePioGoogleDriveProd,
		ProductKeys3P.ForgePioGuruDev,
		ProductKeys3P.ForgePioGuruProd,
		ProductKeys3P.ForgePioHelpjuiceDev,
		ProductKeys3P.ForgePioHelpjuiceProd,
		ProductKeys3P.ForgePioHubspotDev,
		ProductKeys3P.ForgePioHubspotProd,
		ProductKeys3P.ForgePioSalesforceDev,
		ProductKeys3P.ForgePioSalesforceProd,
		ProductKeys3P.ForgePioSharepointDev,
		ProductKeys3P.ForgePioSharepointProd,
		ProductKeys3P.ForgePioStackOverflowDev,
		ProductKeys3P.ForgePioStackOverflowProd,
		ProductKeys3P.ForgeUnitoAsanaDev,
		ProductKeys3P.ForgeUnitoAsanaProd,
		ProductKeys3P.ForgeUnitoBasecampDev,
		ProductKeys3P.ForgeUnitoBasecampProd,
		ProductKeys3P.ForgeUnitoSalesforceDev,
		ProductKeys3P.ForgeUnitoSalesforceProd,
		ProductKeys3P.ForgeUnitoServicenowDev,
		ProductKeys3P.ForgeUnitoServicenowProd,
		ProductKeys3P.ForgeUnitoWrikeDev,
		ProductKeys3P.ForgeUnitoWrikeProd,
		ProductKeys3P.ForgeUtoolityGitbookDev,
		ProductKeys3P.ForgeUtoolityGitbookProd,
		ProductKeys3P.Github,
		ProductKeys3P.Gmail,
		ProductKeys3P.GoogleDrive,
		ProductKeys3P.Hubspot,
		ProductKeys3P.JiraDC,
		ProductKeys3P.JsmDC,
		ProductKeys3P.Loom,
		ProductKeys3P.Lucid,
		ProductKeys3P.Miro,
		ProductKeys3P.Notion,
		ProductKeys3P.OneDrive,
		ProductKeys3P.OutlookMail,
		ProductKeys3P.Salesforce,
		ProductKeys3P.ServiceNow,
		ProductKeys3P.Sharepoint,
		ProductKeys3P.Slack,
		ProductKeys3P.Smartsheet,
		ProductKeys3P.Teams,
		ProductKeys3P.Zendesk,
		ProductKeys3P.Gong,
		ProductKeys3P.Zoom,
	],
	lastUpdatedBy: [ProductKeys3P.Hubspot, ProductKeys3P.Salesforce],
	opportunityStatus: [ProductKeys3P.Salesforce],
	onlyTitleMatch: [
		ProductKeys3P.Airtable,
		ProductKeys3P.Asana,
		ProductKeys3P.Box,
		ProductKeys3P.ConfluenceDC,
		ProductKeys3P.Databricks,
		ProductKeys3P.Docusign,
		ProductKeys3P.Dropbox,
		ProductKeys3P.Github,
		ProductKeys3P.GoogleDrive,
		ProductKeys3P.Hubspot,
		ProductKeys3P.Miro,
		ProductKeys3P.Notion,
		ProductKeys3P.OneDrive,
		ProductKeys3P.OutlookMail,
		ProductKeys3P.Salesforce,
		ProductKeys3P.ServiceNow,
		ProductKeys3P.Sharepoint,
		ProductKeys3P.Smartsheet,
		ProductKeys3P.Zendesk,
		ProductKeys3P.Gong,
		ProductKeys3P.Zoom,
	],
	owner: [ProductKeys3P.Salesforce],
	project: [ProductKeys3P.JiraDC, ProductKeys3P.JsmDC],
	pullRequestStatus: [
		ProductKeys3P.ForgePioGithubDev,
		ProductKeys3P.ForgePioGithubProd,
		ProductKeys3P.ForgePioGitlabDev,
		ProductKeys3P.ForgePioGitlabProd,
		ProductKeys3P.Github,
		ProductKeys3P.Gitlab,
	],
	// TODO: when cleaning up `rovo_fps_show_repository_filter`, add Github + ForgePioGithubDev/Prod here.
	repository: [],
	reviewer: [
		ProductKeys3P.ForgePioGithubDev,
		ProductKeys3P.ForgePioGithubProd,
		ProductKeys3P.Github,
	],
	slackChannel: [ProductKeys3P.Slack],
	space: [ProductKeys3P.ConfluenceDC, ProductKeys3P.GoogleDrive, ProductKeys3P.Sharepoint],
	hasAttachment: [ProductKeys3P.Teams],
	// workspaceName is always in ThirdPartyConfigs.filters for Teams (gate controls filterIdOrdering only)
	workspaceName: [ProductKeys3P.Teams],
};
